// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"CoreLayout__mainContainer___3dKvB","activeMenu":"CoreLayout__activeMenu___255-7","activeMenuAdmin":"CoreLayout__activeMenuAdmin___wi-ob","activeLink":"CoreLayout__activeLink___Tan33","activeLinkAdmin":"CoreLayout__activeLinkAdmin___1eJaP"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/CoreLayout/CoreLayout.scss
// module id = 1321
// module chunks = 0